export default __webpack_public_path__ + "src/images/packages/hillsneck-safari-lodge/683bf96f35127e459ae175d02c3c1e11-HillsNek Safari Camp_1.jpg";